import { Component, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-not-qualified',
  standalone: false,
  templateUrl: './expired-quote.component.html',
  styleUrl: '../../../assets/css/HighLimitsDialogs.css'
})
export class ExpiredQuoteComponent {
  readonly dialogRef = inject(MatDialogRef<ExpiredQuoteComponent>);

  constructor() {
  }

  close() {
    localStorage.clear();
    this.dialogRef.close(false);
  }
}
